export default "__VITE_ASSET__BQ88x8CU__"